import React, { useState, useEffect } from "react";
import moment from "moment";

import { useTranslation } from "react-i18next";
import { getCaseList } from "services/case_service";
import { Link } from "react-router-dom";
import "css/main.css";
import "css/style.css";

import Topnav from "components/Topnav";

function ReportProblem() {
  const { t } = useTranslation();
  const [caseList, setCaseList] = useState([]);

  useEffect(() => {
    async function getCases() {
      try {
        const caseLi = await getCaseList();
        //TODO PARTIR CLOSED E ABERTOS
        setCaseList(caseLi.data.data);
      } catch (exception) {
        console.log("exception: ", exception);
      }
    }

    getCases();
  }, []);

  return (
    <div className="geral">
      <Topnav></Topnav>
      <div className="conteudo">
        <div className="conteudo-container">
          <section className="section">
            <nav className="breadcrumb" aria-label="breadcrumbs">
              <ul>
                <li className="is-active">
                  {t("help_center")}
                </li>
              </ul>
            </nav>

            <div className="hero is-footsolution">
              <div className="columns">
                <div className="column">
                  <h1 className="title is-3">{t("my_tickets")}</h1>
                </div>
                <div className="column">
                  <div className="buttons is-right">
                    <Link to={"/reportar-problema"}>
                      {" "}
                      <button
                        href="reportar-problema.html"
                        className="button is-link btn1"
                      >
                        {t("create_request")}
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            <div className="list is-footsolution">
              <div className="columns">
                <div className="column is-8">
                  <div className="ticket-active">
                    {caseList
                      .filter((el) => el.attributes.status !== "closed")
                      .map((el, index) => (
                        <Link
                          className="box-link"
                          to={`../casos/${el.id}`}
                          key={index}
                        >
                          <div className="box-footsolution">
                            <div className="columns">
                              <div className="column is-10">
                                <h2 className="subtitle is-5">
                                  {el.attributes.body.substring(0, 50)}
                                </h2>
                                <p className="resume">
                                  {el.attributes.description.substring(0, 50)}
                                </p>
                              </div>
                              <div className="column">
                                <p className="ident-ticket is-end">
                                  <time>
                                    {moment(el.attributes.updatedAt).format(
                                      "YYYY-MM-DD HH:mm"
                                    )}
                                  </time>
                                </p>
                              </div>
                            </div>
                            <p className="ident-ticket">
                              <span
                                className={`tag is-rounded is-${el.attributes.status.toLowerCase()} is-footsolution`}
                              >
                                {t(el.attributes.status)}
                              </span>
                              {/* Case NUM. Not defined for now. <span className="ticket-number">#MZ04</span>{" "} */}
                              <span className="comments">
                                <span className="icon">
                                  {" "}
                                  <i className="fa fa-comment"></i>
                                </span>{" "}
                                {el?.attributes?.case_comments?.data?.length
                                  ? el.attributes.case_comments.data.length
                                  : 0}
                              </span>
                            </p>
                          </div>
                        </Link>
                      ))}
                  </div>

                  <div className="ticket-closed">
                    <hr />

                    {caseList
                      .filter((el) => el.attributes.status === "closed")
                      .map((el, index) => (
                        <Link
                          className="box-link"
                          to={`../casos/${el.id}`}
                          key={index}
                        >
                          <div className="box-footsolution">
                            <div className="columns">
                              <div className="column is-10">
                                <h2 className="subtitle is-5">
                                  {el.attributes.body.substring(0, 50)}
                                </h2>
                                <p className="resume">
                                  {el.attributes.description.substring(0, 50)}
                                </p>
                              </div>
                              <div className="column">
                                <p className="ident-ticket is-end">
                                  <time>
                                    {moment(el.attributes.updatedAt).format(
                                      "YYYY-MM-DD HH:mm"
                                    )}
                                  </time>
                                </p>
                              </div>
                            </div>
                            <p className="ident-ticket">
                              <span
                                className={`tag is-rounded is-${el.attributes.status.toLowerCase()} is-footsolution`}
                              >
                                {t(el.attributes.status)}
                              </span>
                              {/* <span className="ticket-number">#MZ04</span>{" "} */}
                              <span className="comments">
                                <span className="icon">
                                  {" "}
                                  <i className="fa fa-comment"></i>
                                </span>{" "}
                                {el?.attributes?.case_comments?.data?.length
                                  ? el.attributes.case_comments.data.length
                                  : 0}
                              </span>
                            </p>
                          </div>
                        </Link>
                      ))}
                  </div>
                </div>

                <div className="column">
                  <div className="box-footsolution extra">
                    <h2 className="title is-5">{t("case_counter")}</h2>
                    <div className="container-counter">
                      <ul>
                        <li>
                          <p>
                            <span className="counter-number is-new">
                              {
                                caseList.filter(
                                  (el) => el.attributes.status === "new"
                                ).length
                              }
                            </span>
                            <span>{t("new_ticket")}</span>
                          </p>
                        </li>
                        <li>
                          <p>
                            <span className="counter-number is-open">
                              {
                                caseList.filter(
                                  (el) => el.attributes.status === "open"
                                ).length
                              }
                            </span>{" "}
                            <span>{t("open_ticket")}</span>
                          </p>
                        </li>
                        <li>
                          <p>
                            <span className="counter-number is-closed">
                              {
                                caseList.filter(
                                  (el) => el.attributes.status === "closed"
                                ).length
                              }
                            </span>{" "}
                            <span>{t("closed_ticket")}</span>
                          </p>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}

export default ReportProblem;
